"use strict";
// https://www.figma.com/file/MFiT49pcOXpVZcxFsNg0JT/Swegon-Design-Suite?node-id=457%3A13
Object.defineProperty(exports, "__esModule", { value: true });
exports.CORNER_RADIUS_ROUND = exports.CORNER_RADIUS_SMALL = exports.CORNER_RADIUS_NONE = void 0;
// Corner Radius
exports.CORNER_RADIUS_NONE = 0;
exports.CORNER_RADIUS_SMALL = "2px";
exports.CORNER_RADIUS_ROUND = "32px";
//# sourceMappingURL=layout.js.map